module.exports = __webpack_public_path__ + "res/27-img_card_bg_odd.bf420515d4a6d3f263dcfd8860046fe0.png";